export const ME_URL = '/api/me';
export const CREATE_ACCOUNT_URL = '/api/user';
export const LOG_IN_URL = '/auth/login';
export const LOG_OUT_URL = '/auth/logout';
export const USER_EXISTS_URL = '/api/user/exists';
export const FORGOT_PASSWORD = '/auth/forgot_password';
export const CHANGE_PASSWORD = '/auth/change_password';
export const DOCS = '/api/docs';
export const VALIDATE_RESET_HASH = '/auth/validate_reset_hash';
export const USER_HAS_AAM_URL = '/api/user/aam-subscription/exists';
